import { render, staticRenderFns } from "./buttons-top.vue?vue&type=template&id=4fb7107e&scoped=true&"
import script from "./buttons-top.vue?vue&type=script&lang=js&"
export * from "./buttons-top.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb7107e",
  null
  
)

export default component.exports